const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const MAX_HEX_LENGTH = 32;

/** Formatea la entrada como UUID: 8-4-4-4-12 hex con guiones en posiciones estándar */
export const formatGenerationIdInput = (raw: string): string => {
  const hex = raw
    .replace(/[^0-9a-fA-F]/g, '')
    .slice(0, MAX_HEX_LENGTH)
    .toLowerCase();

  const segments: string[] = [];
  if (hex.length > 0) segments.push(hex.slice(0, 8));
  if (hex.length > 8) segments.push(hex.slice(8, 12));
  if (hex.length > 12) segments.push(hex.slice(12, 16));
  if (hex.length > 16) segments.push(hex.slice(16, 20));
  if (hex.length > 20) segments.push(hex.slice(20, 32));

  return segments.join('-');
};

export const isCompleteGenerationId = (value: string): boolean => UUID_REGEX.test(value);
